import { VidioHelpers } from 'shared/vidio_helpers';
import AhoyEvent from 'shared/ahoy_event';
const Cookies = require('js-cookie');

export default class AhoyTracker {
  constructor(element, propsCustom = {}) {
    this.element = element;
    this.title   = element.dataset.ahoyTitle;
    this.props   = element.dataset.ahoyProps;
    this.propsImpression = element.dataset.ahoyImpressionProps;
    this.propsClick = element.dataset.ahoyClickProps;
    this.propsCustom = propsCustom;
    this.data = element.dataset;
    this.impressionSent = false;
  }

  init() {
    if (this.data.ahoyloaded == undefined && this.title != undefined) {
      this.data.ahoyloaded = 'true';

      this.setSearchUUID();

      if(this.data.ahoySend != undefined) {
        this.sendEvent();
      }
      if(this.data.ahoyClick != undefined) {
        this.bindClick();
      }
      if(this.data.ahoyImpression != undefined) {
        this.bindImpression();
      }
    }
  }

  getEventTitle(){
    var title = this.title ? this.title : 'UNTITLED';
    return 'VIDIO::' + title.toUpperCase();
  }

  setSearchUUID(){
    if (this.title.toLowerCase() == 'search') {
      var props = JSON.parse(this.props);
      var search_uuid = Cookies.get('search_uuid');
      props.search_uuid = search_uuid == undefined ? VidioHelpers.generateId() : search_uuid;
      this.props = JSON.stringify(props);
    }
  }

  getEventProps(addProps = null){
    try {
      var propsAhoy = JSON.parse(this.props);
      var props = Object.assign(propsAhoy, this.propsCustom);

      if(addProps) {
        addProps = JSON.parse(addProps);
        return Object.assign(props, addProps);
      }
      return props;
    } catch(e) {
      return null;
    }
  }

  sendEvent(props){
    var eventTitle = this.getEventTitle();
    var eventProps = this.getEventProps(props);
    this._sendEvent(eventTitle, eventProps);
  }

  sendEventImpression(){
    if(!this.impressionSent && this.inViewPort()) {
      this.impressionSent = true;
      this.sendEvent(this.propsImpression);
    }
  }

  sendEventClick(){
    if(this.props && this.props.includes('"feature":"typo_suggestion"')) {
      Cookies.set('search_uuid', VidioHelpers.generateId());
    }else{
      this.sendEvent(this.propsClick);
    }
  }

  _sendEvent(title, props){
    if(title && props) {
      AhoyEvent.send(title, props);
    }
  }

  bindClick() {
    var posX = 0;

    this.element.addEventListener('mousedown', function(event) {
      posX = event.clientX;
    }.bind(this));

    this.element.addEventListener('mouseup', function(event) {
      posX -= event.clientX || 0;
      if(posX == 0) {
        this.sendEventClick();
      }
    }.bind(this));
  }

  bindImpression() {
    var parentNode = this.element.parentNode;

    if(this.isReadyStateComplete()) {
      this.sendEventImpression();
    } else {
      window.addEventListener('load', this.sendEventImpression.bind(this));
    }

    window.addEventListener('scroll', this.sendEventImpression.bind(this));
    if(parentNode.scrollWidth > parentNode.clientWidth) {
      parentNode.addEventListener('scroll', this.sendEventImpression.bind(this));
    }
  }

  isReadyStateComplete() {
    return document.readyState == 'complete';
  }

  inViewPort(){
    if("useBoundingClientRect" in this.element.dataset) {
      return this.inBoundRectViewPort();
    } else {
      return VidioHelpers.inViewPort(this.element);
    }
  }

  inBoundRectViewPort(){
    const MINIMUM_VIEWABLE_ELEMENT = 10;

    var rect = this.element.getBoundingClientRect();
    var width = document.documentElement.clientWidth;
    var height = document.documentElement.clientHeight;

    if(rect.height == 0) {
      return false;
    }

    return (!!rect && rect.bottom >= 0 && rect.top + MINIMUM_VIEWABLE_ELEMENT <= height && rect.right >= 0 && rect.left <= width);
  }
}

